import React, { FC, MouseEvent, SyntheticEvent, useState } from 'react';
import Children from 'react-children-utilities';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import CopyIcon from '../../imgs/content_copy.svg';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

export const useStyles = makeStyles(() => ({
	copyText: {
		'& img': {
			opacity: 0,
			transition: '500ms',
			verticalAlign: 'middle'
		},
		'&:hover img': {
			opacity: 0.4
		}
	},
	success: {
		verticalAlign: 'middle',
		marginRight: '0.8rem'
	}
}));

const CopyText: FC<CopyTextProps> = (props) => {
	const { children, tooltip } = props;
	const [snackOpen, setSnackOpen] = useState(false);
	const classes = useStyles();

	const copyHandler = async (text: string): Promise<void> => {
		navigator.clipboard.writeText(text);
		setSnackOpen(true);
	};

	const closeSnackHandler = (event: SyntheticEvent | MouseEvent, reason?: string): void => {
		if (reason === 'clickaway') {
			return;
		}
		setSnackOpen(false);
	};

	const renderCopyIcon = (): JSX.Element => {
		if (tooltip)
			return (
				<Tooltip title={tooltip}>
					<IconButton aria-label='copy to clipboard' size='small' onClick={(): Promise<void> => copyHandler(Children.onlyText(children))}>
						<img src={CopyIcon} alt='Copy' />
					</IconButton>
				</Tooltip>
			);

		return (
			<IconButton aria-label='copy to clipboard' size='small' onClick={(): Promise<void> => copyHandler(Children.onlyText(children))}>
				<img src={CopyIcon} alt='Copy' />
			</IconButton>
		);
	};

	return (
		<>
			<span className={classes.copyText}>
				{children} {renderCopyIcon()}
			</span>
			<Snackbar
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				open={snackOpen}
				autoHideDuration={2000}
				onClose={closeSnackHandler}
				message={
					<span>
						<CheckCircleOutlineIcon className={classes.success} />
						Copied to clipboard
					</span>
				}
			/>
		</>
	);
};

type CopyTextProps = {
	children: JSX.Element | string;
	tooltip?: string;
};

export default CopyText;
